// window.baseUrl = 'http://localhost:8080/'
// window.imgUrl = 'http://localhost:8080/'
window.baseUrl = '/'
window.imgUrl = '/'